import _ from "lodash";
import React, { Component, Suspense, lazy } from "react";
import { connect } from "react-redux";
import { Row, Col, FormGroup, Radio } from "react-bootstrap";
import WebsiteSettings from "./websitesettings";
import ChangeTemplate from "./changetemplate";
import LocaleStrings from "Languages";

class Settings extends Component {
  constructor(props) {
    super(props);
  }

  componentDidMount() {}

  render() {
    var { session } = this.props;
    let { deviceSize } = this.props;

    return (
      <Row
        className="scrollable-content panel-body"
        style={{ height: deviceSize.height - 75 }}
      >
        <div className="row">
          <div className="website-header">{LocaleStrings.website_settings}</div>
          <div className="website-settings">
            <WebsiteSettings />
          </div>
        </div>
        <div className="row">
          <div className="website-header">
            {LocaleStrings.website_settings_changetemplate}
          </div>
          <div className="website-settings-changetemplate">
            <ChangeTemplate />
            <div className="warning-alert">
              <img
                src="../../style/images/header-icons/warning.png"
                style={{ paddingRight: 10 }}
              />
              Changing template will delete all the changes you’ve made (eg.
              Color, Fonts, Texts, Images) and will be replaced to the default
              state.
            </div>
          </div>
        </div>
      </Row>
    );
  }
}

function mapStateToProps(state) {
  return {
    session: state.session,
    deviceSize: state.deviceSize,
  };
}

export default connect(mapStateToProps, {})(Settings);
